import React, { useContext } from 'react';

import { PremiumFeatureGuard } from '@qality/common-components/src/atoms/PremiumFeatureGuard';
import { ClosableBannerWithCounter } from '@qality/common-components/src/molecules/ClosableBannerWithCounter';
import { TestExecutionPageContext } from '@qality/common-state';

import {
  LinkStyled,
  WhitespaceStyled,
} from './TestExecutionCycleNavigationBanner.styled';

const openNavigationDocsPage = () => {
  window.open('https://soldevelo.atlassian.net/l/cp/VFuDXT1P', '_blank');
};

type Props = {
  isInTestCycle: boolean;
  testId?: string;
};

export default function TestExecutionCycleNavigationBanner({
  isInTestCycle,
  testId = 'test-execution-cycle-navagiation-banner',
}: Props): JSX.Element {
  const { currentUser } = useContext(TestExecutionPageContext);

  const getTestId = (element: string) => {
    return `${testId}-${element}`;
  };

  return (
    <PremiumFeatureGuard
      premium={<WhitespaceStyled data-testid='whitespace' />}
      free={
        isInTestCycle ? (
          <ClosableBannerWithCounter
            currentUser={currentUser}
            counterKey='TEST_EXECUTION_CYCLE_NAVIGATION_BANNER_CLOSE_COUNTER'
          >
            <span data-testid={getTestId('message')}>
              QAlity Plus users save time with easier navigation between Test
              Cases in the Test Cycles.{' '}
              <LinkStyled
                onClick={openNavigationDocsPage}
                data-testid={getTestId('message-link')}
              >
                Learn more about improved navigation
              </LinkStyled>
            </span>
          </ClosableBannerWithCounter>
        ) : (
          <WhitespaceStyled data-testid='whitespace' />
        )
      }
    />
  );
}
